module.exports = __webpack_public_path__ + "img/canbadge-round-57mm-momo_trimmark.e495a6fe.png";